export default __webpack_public_path__ + "static/media/blog-posts.69ae7d8f.png";